
import { supabase } from "@/integrations/supabase/client";
import { getPlanRoutines } from "./getPlanRoutines";
import { copyRoutineWithExercises } from "./copyRoutine";

export const copyPlanRoutines = async (planId: string, newPlanId: string, userId: string) => {
  console.log("Copying routines for plan:", planId, "to new plan:", newPlanId);
  
  try {
    // Get all routines from original plan
    const routines = await getPlanRoutines(planId);
    console.log("Original routines to copy:", routines);

    // Create isolated copies of each routine
    for (const routine of routines) {
      try {
        // Create a new routine with proper ownership
        const newRoutine = await copyRoutineWithExercises(routine, userId);
        
        // Link new routine to the new plan
        const { error: linkError } = await supabase
          .from('workout_plan_routines')
          .insert({
            workout_plan_id: newPlanId,
            routine_id: newRoutine.id
          });

        if (linkError) {
          console.error("Error linking routine to plan:", linkError);
        } else {
          console.log("Linked new routine to plan:", newRoutine.id);
        }
      } catch (routineError) {
        console.error("Error copying individual routine:", routineError);
        // Continue with next routine even if one fails
      }
    }

    console.log("Successfully copied all routines to new plan");
  } catch (error) {
    console.error("Error in copyPlanRoutines:", error);
    throw error;
  }
};
